import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '../../../../components/accordion';
import { Container } from '../../../../components/container';
import { Row } from '../../../../components/row';
import { Cell } from '../../../../components/cell';
import { CitizenAttendanceStatisticsSummaryDto } from '../../../../api-service/clients';
import { AttendanceStatisticsResultSummary } from './attendance-statistics-result-summary';
import { AttendanceStatisticsResultTable } from './attendance-statistics-result-table';
import { AttendanceStatisticsLesson } from '../interfaces';

interface IAttendanceStatisticsResultProps {
  summary?: CitizenAttendanceStatisticsSummaryDto;
  lessons?: AttendanceStatisticsLesson[];
  showLessonDetails: boolean;
}

export function AttendanceStatisticsResult(props: IAttendanceStatisticsResultProps) {
  const { summary, lessons, showLessonDetails } = props;

  return (
    summary && (
      <Accordion defaultExpanded>
        <AccordionSummary>Fremmødestatistik resultater</AccordionSummary>
        <AccordionDetails>
          <Container>
            <Row>
              <Cell size="full">
                <AttendanceStatisticsResultSummary summary={summary} />
              </Cell>
            </Row>
            <Row>
              <Cell size="full">
                <AttendanceStatisticsResultTable lessons={lessons || []} showLessonDetails={showLessonDetails} />
              </Cell>
            </Row>
          </Container>
        </AccordionDetails>
      </Accordion>
    )
  );
}
